import { NavLink } from "react-router-dom";
import PageLayout from "components/layout/PageLayout";

import { useDeleteEmployeeMutation, useGetEmployeesQuery, useSetEmployeeStatusMutation } from "./api/employmentApiSlice";
import EmploymentsTable from './components/EmploymentsTable';
import { useTranslation } from "react-i18next";

const ManageEmployees = () => {

    const [t, i18n] = useTranslation(["global"])

    const {
        data: employmentsData,
        isLoading,
        isFetching,
        isSuccess,
        isError,
        error,
        refetch,
    } = useGetEmployeesQuery()

    const [
        setStatusRequest, {
            isLoading: employeeStatusChangeIsLoading,
            isSuccess: employeeStatusChangeIsSuccess
        }
    ] = useSetEmployeeStatusMutation()

    const [
        deleteEmployee, {
            isLoading: deleteEmployeeIsLoading,
            isSuccess: deleteEmployeeIsSuccess
        }
    ] = useDeleteEmployeeMutation()

    const handelStatusChange = (newStatus, guid) => {
        console.log("Received Event toggleStatus: " + newStatus + " on UserGuid: " + guid)
        setStatusRequest({
            newStatus: newStatus,
            userGuid: guid
        })
    }

    const handelEmployeDelete = (guid) => {
        deleteEmployee(guid)
    }

    let content;
    if (isSuccess) {

        content = (
            <>
                <div className="row mb-4">
                    <div className="col text-end">
                        <NavLink to={"/dashboard/employees/new-employment"} className="btn btn-primary">
                            <i className="fa-solid fa-circle-plus"></i>  {t("action.add")}
                        </NavLink>
                    </div>
                </div>

                <EmploymentsTable
                    employmentsData={employmentsData}
                    toggleStatus={handelStatusChange}
                    onUserDelete={handelEmployeDelete}
                />
            </>
        )
    }

    return <PageLayout
        pageTitle={t("entity.users")}
        isLoadingPage={isLoading}
        isLoadingContent={isFetching || employeeStatusChangeIsLoading}
        onPageRefresh={refetch}
        bodyContent={content}
        isError={isError}
        errorMsg={error}
    />
}

export default ManageEmployees